import { render, staticRenderFns } from "./detailGiveMember.vue?vue&type=template&id=7835e328&"
import script from "./detailGiveMember.vue?vue&type=script&lang=js&"
export * from "./detailGiveMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports